import { Button, Card, Col, Row, Statistic } from 'antd'
import {
	ArrowRightOutlined,
	PlusOutlined,
	ThunderboltOutlined,
	ToolOutlined
} from '@ant-design/icons'
import { FC, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { relayStore } from '../store/relay'
import { PageBreadcrumb } from '../components/PageBreadcrumb'
import { RNChecksElectric, RNChecksMechanic } from '../helpers/routeNames'

export const Checks: FC = () => {
	const { relayTypes } = relayStore()
	const navigate = useNavigate()

	const totalMechanics = useMemo(
		() =>
			relayTypes.reduce(
				(sum, rt) => sum + (rt.mechanics?.length ?? 0),
				0
			),
		[relayTypes]
	)

	const totalElectrics = useMemo(
		() =>
			relayTypes.reduce(
				(sum, rt) => sum + (rt.electrics?.length ?? 0),
				0
			),
		[relayTypes]
	)

	const mechanicRelayTypes = useMemo(
		() => relayTypes.filter((rt) => (rt.mechanics?.length ?? 0) > 0).length,
		[relayTypes]
	)

	const electricRelayTypes = useMemo(
		() => relayTypes.filter((rt) => (rt.electrics?.length ?? 0) > 0).length,
		[relayTypes]
	)

	return (
		<div style={{ padding: '16px 16px 90px' }}>
			<PageBreadcrumb items={[{ label: 'Характеристики' }]} />

			<h1 style={{ fontSize: 28, fontWeight: 700, margin: '8px 0 24px' }}>
				Характеристики
			</h1>

			<Row gutter={[20, 20]}>
				{/* Mechanic card */}
				<Col xs={24} md={12}>
					<Card
						hoverable
						style={{
							borderRadius: 16,
							overflow: 'hidden',
							border: 'none',
							boxShadow: '0 4px 24px rgba(22, 119, 255, 0.10)'
						}}
						styles={{ body: { padding: 0 } }}>
						{/* Gradient header */}
						<div
							style={{
								background:
									'linear-gradient(135deg, #1677ff 0%, #69b4ff 100%)',
								padding: '36px 24px 28px',
								textAlign: 'center'
							}}>
							<div
								style={{
									width: 80,
									height: 80,
									borderRadius: '50%',
									background: 'rgba(255,255,255,0.2)',
									display: 'inline-flex',
									alignItems: 'center',
									justifyContent: 'center',
									marginBottom: 16
								}}>
								<ToolOutlined
									style={{ fontSize: 40, color: '#fff' }}
								/>
							</div>
							<h2
								style={{
									color: '#fff',
									margin: '0 0 4px',
									fontSize: 20,
									fontWeight: 600
								}}>
								Механические
							</h2>
							<p
								style={{
									color: 'rgba(255,255,255,0.8)',
									margin: 0,
									fontSize: 14
								}}>
								Управление механическими параметрами реле
							</p>
						</div>

						{/* Stats */}
						<div style={{ padding: '24px 24px 8px' }}>
							<Row gutter={16}>
								<Col span={8}>
									<Statistic
										title="Типов реле"
										value={relayTypes.length}
										valueStyle={{ fontSize: 24, fontWeight: 700 }}
									/>
								</Col>
								<Col span={8}>
									<Statistic
										title="С характер."
										value={mechanicRelayTypes}
										valueStyle={{
											fontSize: 24,
											fontWeight: 700,
											color: '#1677ff'
										}}
									/>
								</Col>
								<Col span={8}>
									<Statistic
										title="Всего хар."
										value={totalMechanics}
										valueStyle={{ fontSize: 24, fontWeight: 700 }}
									/>
								</Col>
							</Row>
						</div>

						{/* Action buttons */}
						<div
							style={{
								padding: '16px 24px 24px',
								display: 'flex',
								gap: 12
							}}>
							<Button
								type="primary"
								icon={<ArrowRightOutlined />}
								size="large"
								block
								onClick={() => navigate(RNChecksMechanic)}>
								Открыть
							</Button>
							<Button
								icon={<PlusOutlined />}
								size="large"
								block
								onClick={() =>
									navigate(RNChecksMechanic + '?add=true')
								}>
								Добавить
							</Button>
						</div>
					</Card>
				</Col>

				{/* Electric card */}
				<Col xs={24} md={12}>
					<Card
						hoverable
						style={{
							borderRadius: 16,
							overflow: 'hidden',
							border: 'none',
							boxShadow: '0 4px 24px rgba(250, 140, 22, 0.10)'
						}}
						styles={{ body: { padding: 0 } }}>
						{/* Gradient header */}
						<div
							style={{
								background:
									'linear-gradient(135deg, #fa8c16 0%, #ffc53d 100%)',
								padding: '36px 24px 28px',
								textAlign: 'center'
							}}>
							<div
								style={{
									width: 80,
									height: 80,
									borderRadius: '50%',
									background: 'rgba(255,255,255,0.2)',
									display: 'inline-flex',
									alignItems: 'center',
									justifyContent: 'center',
									marginBottom: 16
								}}>
								<ThunderboltOutlined
									style={{ fontSize: 40, color: '#fff' }}
								/>
							</div>
							<h2
								style={{
									color: '#fff',
									margin: '0 0 4px',
									fontSize: 20,
									fontWeight: 600
								}}>
								Электрические
							</h2>
							<p
								style={{
									color: 'rgba(255,255,255,0.8)',
									margin: 0,
									fontSize: 14
								}}>
								Управление электрическими параметрами реле
							</p>
						</div>

						{/* Stats */}
						<div style={{ padding: '24px 24px 8px' }}>
							<Row gutter={16}>
								<Col span={8}>
									<Statistic
										title="Типов реле"
										value={relayTypes.length}
										valueStyle={{ fontSize: 24, fontWeight: 700 }}
									/>
								</Col>
								<Col span={8}>
									<Statistic
										title="С характер."
										value={electricRelayTypes}
										valueStyle={{
											fontSize: 24,
											fontWeight: 700,
											color: '#fa8c16'
										}}
									/>
								</Col>
								<Col span={8}>
									<Statistic
										title="Всего хар."
										value={totalElectrics}
										valueStyle={{ fontSize: 24, fontWeight: 700 }}
									/>
								</Col>
							</Row>
						</div>

						{/* Action buttons */}
						<div
							style={{
								padding: '16px 24px 24px',
								display: 'flex',
								gap: 12
							}}>
							<Button
								type="primary"
								icon={<ArrowRightOutlined />}
								size="large"
								block
								onClick={() => navigate(RNChecksElectric)}>
								Открыть
							</Button>
							<Button
								icon={<PlusOutlined />}
								size="large"
								block
								onClick={() =>
									navigate(RNChecksElectric + '?add=true')
								}>
								Добавить
							</Button>
						</div>
					</Card>
				</Col>
			</Row>
		</div>
	)
}
